import React from 'react';
import '../../search/assets/css/date-search.css';

export const NextArrow = ({ onClick, nextArrowImage }) => (
  <div className='date-search-arrow date-search-arrow--next' onClick={onClick}>
    <img src={nextArrowImage} alt='Next' />
  </div>
);

export const PrevArrow = ({ onClick, prevArrowImage }) => (
  <div className='date-search-arrow date-search-arrow--prev' onClick={onClick}>
    <img src={prevArrowImage} alt='Previous' />
  </div>
);
